import React from 'react';
import FormControl from '@material-ui/core/FormControl/FormControl';
import TextField from '@material-ui/core/TextField/TextField';
import IconButton from '@material-ui/core/IconButton/IconButton';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import InCardTextFieldWrapper from 'hcla-web-frontend-primitives/app/components/primitives/TextField/InCardTextFieldWrapper';

const styles = theme => ({
  formControl: {
    flexDirection: 'row',
  },

  leftChild: {
    marginRight: `${theme.spacing.unit / 2}px`,
  },

  rightChild: {
    marginLeft: `${theme.spacing.unit / 2}px`,
  },

  fieldContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    border: '1px solid #ccc',
    margin: '8px 0px',
    background: '#f5f5f5',
    borderRadius: '4px',
    padding: '8px',
  },

  cancelButton: {
    height: '32px',
    width: '32px',
    margin: '10px 8px 0px 0px',
    padding: '0px',
  },
});

class TwoNumberFields extends React.Component {
  onChangeTop = (event, value) => {
    const newValue = Number(value);
    const values = this.getPropVals();
    this.props.onUpdate(event, this.props.index, [newValue, values[1]]);
  };

  onChangeBottom = (event, value) => {
    const newValue = Number(value);
    const values = this.getPropVals();
    this.props.onUpdate(event, this.props.index, [values[0], newValue]);
  };

  getPropVals = () => {
    const v = this.props.selected;
    try {
      return [v[0], v[1]];
    } catch (e) {
      return [NaN, NaN];
    }
  };

  render() {
    const {
      classes, labels, index, onRemove, disable
    } = this.props;
    const values = this.getPropVals();
    return (
      <div className={classes.fieldContainer} key={index}>
        <IconButton
          size="small"
          color="secondary"
          aria-label="remove"
          className={classes.cancelButton}
          onClick={e => onRemove(e, index)}
          disabled={disable && disable.values}
        >
          <CancelIcon />
        </IconButton>
        <FormControl className={classes.formControl} noValidate autoComplete="off">
          <div className={classes.leftChild}>
            <InCardTextFieldWrapper>
              <TextField
                autoFocus
                label={labels.first}
                type="number"
                value={values[0]}
                onChange={e => this.onChangeTop(e, e.target.value)}
                disabled={disable && disable.values}
              />
            </InCardTextFieldWrapper>
          </div>
          <div className={classes.rightChild}>
            <InCardTextFieldWrapper>
              <TextField
                label={labels.second}
                type="number"
                value={values[1]}
                onChange={e => this.onChangeBottom(e, e.target.value)}
                disabled={disable && disable.values}
              />
            </InCardTextFieldWrapper>
          </div>
        </FormControl>
      </div>
    );
  }
}

TwoNumberFields.propTypes = {
  index: PropTypes.number.isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
  onUpdate: PropTypes.instanceOf(Function).isRequired,
  onRemove: PropTypes.instanceOf(Function).isRequired,
  labels: PropTypes.shape({
    first: PropTypes.string.isRequired,
    second: PropTypes.string.isRequired,
  }).isRequired,
  selected: PropTypes.arrayOf(Number).isRequired,
};

export default withStyles(styles)(TwoNumberFields);
